import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewRecorridoDefault = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'recorrido_default',
        name: 'Recorrido Default',
        component: ViewRecorridoDefault,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
